import Vue from 'vue'
import LStudyDialog from '@/components/l-dialog'
import LOverallDialog from '@/components/l-overall-dialog'
let instance = null
const LDialogConstructor = Vue.extend(LStudyDialog)
const LOverallDialogConstructor = Vue.extend(LOverallDialog)

Vue.mixin({
  beforeCreate() {
    if (!this.$lPrompt) {
      this.$lPrompt = lPrompt
    }
  }
})
/**
 * @description 弹窗提示
 * @param {any} Boolean 关闭弹窗 ｜ Object 弹窗提示参数
 * @returns
 */
function lPrompt(options) {
  if (options === true && instance) {
    instance.$el.remove()
    instance.$destroy()
    instance = null
    return
  }
  let {
      title = '',
      message = '',
      cancelTxt = '取消',
      successTxt = '确定',
      successFn = null,
      cancelFn = null,
      showCancel = false,
      dialogType = 1,
  } = options

  if (!message) {
    return
  }
  // 单例
  if (!instance) {
    instance = options.type=='overall' ? new LOverallDialogConstructor({
      el: document.createElement('div'),
    }) : new LDialogConstructor({
      el: document.createElement('div'),
    })
  }
  // 初始化值
  instance.visible = true
  instance.dialogType = dialogType
  instance.showCancel = cancelFn instanceof Function ? true : showCancel
  instance.$slots.title = instance.$createElement('div', null, title)
  instance.$slots.msg = typeof message === 'string' ? instance.$createElement('div', null, message) : message
  instance.cancleBtnText = cancelTxt
  instance.confirmBtnText = successTxt
  instance.hasCancleBtn = cancelFn instanceof Function

  // 确定事件
  instance.$on('confirm', function () {
    successFn instanceof Function ? successFn() : ''
    if (instance) {
      instance.$el.remove()
      instance.$destroy()
      instance = null
    }
  })

  // 取消事件
  instance.$on('cancle', function () {
    cancelFn instanceof Function ? cancelFn() : ''
    if (instance) {
      instance.$el.remove()
      instance.$destroy()
      instance = null
    }
  })

  document.body.appendChild(instance.$el)
}

export default lPrompt